import { DocumentTypes } from "store/api/models";
import { confirmUserIdentity } from "store/api/users";
import * as Yup from "yup";

export const businessDetailsValidationSchema = Yup.object().shape({
 // businessType: Yup.string().required("Type of business is a required field"),
 // BVNbusinessaccount: Yup.string().required("BVN is required"),
 // companyreg: Yup.string().required("Company registration type is required"),
  //companyRCnumber: Yup.string().required("Company RC No. is required"),

  //businessSector: Yup.string().required("Business sector is required"),
  numberoflocations: Yup.number().required("Number of locations is required"),

  numberofemployees: Yup.string().required("Number of employees is required"),
  // accessAccountNumber: Yup.string().required(
  //   "Access Bank account number is required"
  // ),

  // bankAccounts: Yup.array().of(
  //   Yup.object().shape({
  //     businessBank: Yup.string().required("Business bank name is required"),
  //     businessAccount: Yup.string()
  //       .matches(/^[0-9]+$/, "Must be only digits")
  //       .required("Business account number is required")
  //       .test(
  //         "Is positive?",
  //         "Business account number must be/above 10 digits",
  //         (value) => value.toString().length >= 10
  //       ),
  //   })
  // ),
});

export const bankAccountDetailsValidationSchema = Yup.object().shape({
  // accessAccountNumber: Yup.string().required(
  //   "Access Bank account number is required"
  // ),

  bankAccounts: Yup.array().of(
    Yup.object().shape({
      businessBank: Yup.string().required("Business bank name is required"),
      businessAccount: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .required("Business account number is required")
        .test(
          "Is positive?",
          "Business account number must be/above 10 digits",
          (value) => value.toString().length >= 10
        ),
    })
  ),
});

// export const directorDetailsValidationSchema = Yup.object().shape({
//   directors: Yup.array()
//     .of(
//       Yup.object().shape({
//         Name: Yup.string().required("Directors name is required"),
//         Bvn: Yup.string()
//           .matches(/^[0-9*]+$/, "Must be only digits")
//           .required("BVN is required!")
//           .test(
//             "Is positive?",
//             "BVN must be 11 digits",
//             (value) => value.toString().length === 11
//           ),
//         TypeOfId: Yup.number().required("ID type is required"),
//         // .oneOf([
//         //   "National Identity Number (NIN)",
//         //   "International Passport",
//         //   "Driver's License",
//         //   "Voter's card",
//         // ])
//         IdNumber: Yup.string()
//           .matches(/^[0-9a-zA-Z]+$/, "Must be only digits")
//           .required("ID number is required!")
//           .test(
//             "Is positive?",
//             "ID number must be at least 11 digits",
//             (value) => value.toString().length >= 6
//           )
//           .ensure()
//           .when("TypeOfId", {
//             is: (TypeOfId: string) => +TypeOfId === 0,
//             then: (schema) =>
//               schema
//                 .required("NIN is required")
//                 .matches(/^[0-9]+$/, "Must be only digits")
//                 .length(11, "NIN must be 11 digits")
//                 .test(
//                   "is Valid License",
//                   "Enter a valid NIN number",
//                   async (value, ctx) => {
//                     if (value.length > 10) {
//                       try {
//                         const res = await confirmUserIdentity(
//                           value,
//                           DocumentTypes.NIN
//                         );
//                         return res?.data?.Data?.IsValid;
//                       } catch (error) {
//                         return ctx.createError({
//                           message: "Unable to validate id number",
//                         });
//                       }
//                     }
//                     return false;
//                   }
//                 ),
//             otherwise: (schema) => schema.notRequired(),
//           })
//           .ensure()
//           .when("TypeOfId", {
//             is: (e: string) => +e === 1,
//             then: (schema) =>
//               schema
//                 .required("ID Number is required")
//                 .matches(/^[0-9a-zA-Z]+$/, "Must contain letters and numbers")
//                 // .length(11, "License must be 11 digits")
//                 .test(
//                   "is Valid License",
//                   "Enter a valid license number",
//                   async (value, ctx) => {
//                     if (value.length > 10) {
//                       try {
//                         const res = await confirmUserIdentity(
//                           value,
//                           DocumentTypes.DriversLicense
//                         );
//                         return res?.data?.Data?.IsValid;
//                       } catch (error) {
//                         return ctx.createError({
//                           message: "Unable to validate id number",
//                         });
//                       }
//                     }
//                     return false;
//                   }
//                 ),
//             otherwise: (schema) => schema.notRequired(),
//           }),
//         // Added async validators to NIN and Drivers License Form fields
//         // nin: Yup.string()
//         //   .ensure()
//         //   .when("TypeOfId", {
//         //     is: (TypeOfId: string) =>
//         //       TypeOfId === "National Identity Number (NIN)",
//         //     then: (schema) =>
//         //       schema
//         //         .required("NIN is required")
//         //         .matches(/^[0-9]+$/, "Must be only digits")
//         //         .length(11, "NIN must be 11 digits")
//         //         .test(
//         //           "is Valid License",
//         //           "Enter a valid NIN number",
//         //           async (value, ctx) => {
//         //             if (value.length > 10) {
//         //               try {
//         //                 const res = await confirmUserIdentity(
//         //                   value,
//         //                   DocumentTypes.NIN
//         //                 );
//         //                 return res?.data?.Data?.IsValid;
//         //               } catch (error) {
//         //                 return ctx.createError({
//         //                   message: "Unable to validate id number",
//         //                 });
//         //               }
//         //             }
//         //             return false;
//         //           }
//         //         ),
//         //     otherwise: (schema) => schema.notRequired(),
//         //   }),
//         // licenseNumber: Yup.string()
//         //   .ensure()
//         //   .when("TypeOfId", {
//         //     is: (e: string) => e === "Driver's License",
//         //     then: (schema) =>
//         //       schema
//         //         .required("ID Number is required")
//         //         .matches(/^[0-9]+$/, "Must be only digits")
//         //         .length(11, "License must be 11 digits")
//         //         .test(
//         //           "is Valid License",
//         //           "Enter a valid license number",
//         //           async (value, ctx) => {
//         //             if (value.length > 10) {
//         //               try {
//         //                 const res = await confirmUserIdentity(
//         //                   value,
//         //                   DocumentTypes.DriversLicense
//         //                 );
//         //                 return res?.data?.Data?.IsValid;
//         //               } catch (error) {
//         //                 return ctx.createError({
//         //                   message: "Unable to validate id number",
//         //                 });
//         //               }
//         //             }
//         //             return false;
//         //           }
//         //         ),
//         //     otherwise: (schema) => schema.notRequired(),
//         //   }),
//         // VotersCard: Yup.mixed().when("TypeOfId", {
//         //   is: (e: string) => e === "Voter's card",
//         //   then: (schema) => schema.required("Voter's card is required"),
//         //   otherwise: (schema) => schema.notRequired(),
//         // }),
//         // InternationalPassport: Yup.mixed().when("TypeOfId", {
//         //   is: (e: string) => e === "International Passport",
//         //   then: (schema) => schema.required("Passport is required"),
//         //   otherwise: (schema) => schema.notRequired(),
//         // }),
//       })
//     )
//     .required("Must have at least one director")
//     .min(1, "Minimum of 1 director"),
// });


export const directorDetailsValidationSchema = Yup.object().shape({
  directors: Yup.array()
    .of(
      Yup.object().shape({
        Name: Yup.string().when("isPrefilled", {
          is: false, // new rows only
          then: (schema) => schema.required("Directors name is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        Bvn: Yup.string()
          .matches(/^[0-9*]+$/, "Must be only digits")
          .when("isPrefilled", {
            is: false,
            then: (schema) =>
              schema
                .required("BVN is required!")
                .test(
                  "Is valid length",
                  "BVN must be 11 digits",
                  (value) => !value || value.toString().length === 11
                ),
            otherwise: (schema) => schema.notRequired(),
          }),
        TypeOfId: Yup.number().when("isPrefilled", {
          is: false,
          then: (schema) => schema.required("ID type is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        IdNumber: Yup.string()
          .matches(/^[0-9a-zA-Z]+$/, "Must be only digits")
          .when("isPrefilled", {
            is: false,
            then: (schema) =>
              schema
                .required("ID number is required!")
                .test(
                  "min length",
                  "ID number must be at least 6 digits",
                  (value) => !value || value.toString().length >= 6
                ),
            otherwise: (schema) => schema.notRequired(),
          }),
      })
    )
    .required("Must have at least one director")
    .min(1, "Minimum of 1 director"),
});



export const businessDocumentationValidationSchema = Yup.object().shape({
  BOARDRESOLUTION: Yup.mixed().required(
    "Board Resolution is required"
  ),
  DIRECTDEBITMANDATE: Yup.mixed().required("Direct debit mandate is required"),
  OFFERLETTER: Yup.mixed().required(
    "Offer Letter is required"
  ),


  // BUSINESSREGISTRATION: Yup.mixed().required(
  //   "Certificate of business registration is required"
  // ),
  // CAC: Yup.mixed().required("CAC document is required"),
  // PERSONALGUARANTEE: Yup.mixed().required("Personal guarantee is required"),
  // STATEMENTOFNETWORTH: Yup.mixed().required(
  //   "Statement of personal networth is required"
  // ),
});

export const securityQestionsValidationSchema = Yup.object().shape({
  securityAnswers: Yup.array()
    .of(
      Yup.object().shape({
        SecurityQuestionId: Yup.number().required("Please select a question"),
        Answer: Yup.string().required("An answer is required!"),
      })
    )
    .required("Must have at least one question")
    .min(1, "Minimum of 1 question"),
});

export const pinValidationSchema = Yup.object().shape({
  pin: Yup.string()
    .required("PIN is Requried")
    .test(
      "Is positive?",
      "PIN is incomplete and must have 4 digits",
      (value) => value.toString().length === 4
    ),
});

export const userSecurityAnswerSchema = Yup.object().shape({
  Answer: Yup.string().required("Please provide a valid answer"),
});

export const securityOtpValidation = Yup.object().shape({
  token: Yup.string()
    .required("Please provide otp sent to your bvn phone number")
    .length(6, "OTP must be six digits"),
});

export const saveSecurityQuestionPayloadSchema = Yup.object().shape({
  securityAnswers: Yup.array().of(
    Yup.object().shape({
      SecurityQuestionId: Yup.number().required("Please select a question"),
      Answer: Yup.string().required("An answer is required!"),
    })
  ),
  pin: Yup.string()
    .required("PIN is Requried")
    .test(
      "Is positive?",
      "PIN is incomplete and must have 4 digits",
      (value) => value.toString().length === 4
    ),
});

export const changePasswordSchema = Yup.object().shape({
  OldPassword: Yup.string()
    .required("Please provide your password")
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  NewPassword: Yup.string()
    .required("Kindly enter a new password")
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  ConfirmNewPassword: Yup.string()
    .required("Enter your new password again to be sure")
    .oneOf([Yup.ref("NewPassword")], "Passwords must match"),
});

export const changePinSchema = Yup.object().shape({
  OldPin: Yup.string()
    .required("PIN is Requried")
    .test(
      "Is positive?",
      "PIN is incomplete and must have 4 digits",
      (value) => value.toString().length === 4
    ),
  NewPin: Yup.string()
    .required("PIN is Requried")
    .test(
      "Is positive?",
      "PIN is incomplete and must have 4 digits",
      (value) => value.toString().length === 4
    ),
  ConfirmNewPin: Yup.string()
    .required("Enter your pin again to be sure")
    .oneOf([Yup.ref("NewPin")], "New Pins must match"),
});
